// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Margin-module--wrapper--2kF5O"};